<div class="vertical-center">
  <app-route-page>
    <div class="d-flex flex-column align-items-center payment-summary-container">
      <div class="d-flex flex-row justify-content-center payment-received-container psic-gap-6">
        <img class="summary-image" [src]="'assets/images/payment-summary.svg'" alt="Payment Summary" />

        <div class="payment-details d-flex flex-column psic-gap-6">
          <div class="d-flex flex-column psic-gap-2">
            @if (!isMobile()) {
              <h2>Payment received!</h2>
            }
            @if (isMobile()) {
              <h4>Payment received!</h4>
            }
            <p class="p-alt">
              {{ globalConstants.paymentSuccess }}
            </p>
          </div>
          <div class="d-flex flex-column psic-gap-4">
            <div class="d-flex flex-row justify-content-between">
              <div class="d-flex flex-column justify-content-center">
                <h5>Total amount</h5>
                @if (chargePaymentResponse()!.chargedProcessingFee) {
                  <span class="caption">
                    Including processing fee: {{chargePaymentResponse()!.convenienceFee | currency: 'USD':'symbol':'1.2-2'}}
                  </span>
                }
              </div>
              <div class="d-flex flex-row align-items-baseline">
                <h2>{{chargePaymentResponse()!.paymentAmount.toString().split('.')[0] | currency: 'USD':'symbol':'0.0-2'}}</h2>
                <p class="alt-bold">
                  .{{ (+chargePaymentResponse()!.paymentAmount).toFixed(2).split('.')[1] }}
                </p>
              </div>
            </div>
            <span class="divider"></span>
            <div class="d-flex flex-column psic-gap-2">
              @if (chargePaymentResponse()?.transactionId) {
                <div class="d-flex flex-row justify-content-between">
                  <p class="p-alt">Transaction ID</p>
                  <lib-button [disabled]="false" [buttonText]="chargePaymentResponse()!.transactionId" [buttonType]="'borderless'"></lib-button>
                </div>
              }
              <div class="d-flex flex-row justify-content-between">
                <p class="p-alt">Policy number</p>
                <p class="p-alt">{{policyDetails()!.policyNumber}}</p>
              </div>
              <div class="d-flex flex-row justify-content-between">
                <p class="p-alt">Payment date</p>
                <p class="p-alt">{{chargePaymentResponse()!.transactionDate | date:'MM/dd/yyyy'}} PDT</p>
              </div>
              <div class="d-flex flex-row justify-content-between">
                <p class="p-alt">Payment method</p>
                <p class="p-alt">{{bankAcctType()}}</p>
              </div>
            </div>
            <span class="divider"></span>
          </div>
          <div class="d-flex align-items-center psic-gap-6 download-buttons">
            <lib-button [buttonSize]="'medium'" [buttonText]="'Download receipt'"
            [iconSrc]="'assets/images/download.svg'" (callback)="downloadReceipt()"></lib-button>
            <lib-button [buttonText]="'Email receipt'" [buttonType]="'borderless'"
            [iconSrc]="'assets/images/send-email.svg'" (callback)="emailReceipt()"></lib-button>
          </div>
        </div>
      </div>
      <div class="d-flex flex-column psic-gap-6 check-out-products">
        @if (!isMobile()) {
          <h3>{{globalConstants.interestedProtectionMsg}}</h3>
        }
        @if (isMobile()) {
          <h6>{{globalConstants.interestedProtectionMsg}}</h6>
        }
        <div class="d-flex flex-row justify-content-center" [ngClass]="{'psic-gap-8': !isMobile(), 'psic-gap-4': isMobile()}">
          @for (item of policies(); track item) {
            <div class="d-flex flex-column psic-gap-2 align-items-center policy-icon" (click)="goToPage(item)">
              <img [src]="item.icon" [alt]="item.product" />
              <span class="disclaimer">{{ item.product }}</span>
            </div>
          }
        </div>
      </div>
    </div>
  </app-route-page>
</div>
